const Cancel = function () {
  this.multipleUserEdit.resetMultipleUserEditModal()
}

export default Cancel
